import type { LucideIcon } from "lucide-react"

interface ComingNextFeatureCardProps {
  title: string
  description: string
  icon: LucideIcon
  items: string[]
}

export function ComingNextFeatureCard({
  title,
  description,
  icon: Icon,
  items,
}: ComingNextFeatureCardProps) {
  return (
    <article className="w-full min-w-full shrink-0 snap-start rounded-xl border border-[var(--color-divider)] bg-[var(--color-bg-primary)] p-4">
      <div className="flex items-start gap-2">
        <Icon size={16} className="mt-0.5 shrink-0 text-[var(--color-text-secondary)]" aria-hidden />
        <div>
          <h2 className="text-lg font-semibold text-[var(--color-text-primary)]">{title}</h2>
          <p className="mt-1 text-sm text-[var(--color-text-secondary)]">{description}</p>
        </div>
      </div>
      <ul className="mt-3 space-y-1 text-sm text-[var(--color-text-primary)]">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <span className="mt-1 text-xs text-[var(--color-text-secondary)]" aria-hidden>
              •
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </article>
  )
}
